import React from 'react';
import { Icon, Spin, StatusPill, InvPill, StatusPicker, MarginChip, StatusDot,
         Drawer, Modal, LargeModal, Tabs, FG, RG, Pagination } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN, showToast } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, ACTIVE_STATUSES, SL, INVOICE, MAT_CAT, MONTHS, VEHICLE_TYPES, VT, VS_COLORS,
         STATUS_COLORS, INV_COLORS, PAGE_SIZE } from '../constants.js';


export const ProjectForm =({project,clients:cp,techs,onSave,onClose})=>{
  const [cl,setCl]=React.useState(cp||[]);
  React.useEffect(()=>setCl(cp||[]),[cp]);
  const [tab,setTab]=React.useState('info');
  const [saving,setSaving]=React.useState(false);
  const [err,setErr]=React.useState('');
  const [ncm,setNcm]=React.useState(false);
  const [ncn,setNcn]=React.useState('');

  const [f,setF]=React.useState({
    title:project?.title||'',
    date_start:project?.date_start?project.date_start.split('T')[0]:'',
    date_end:project?.date_end?project.date_end.split('T')[0]:'',
    client_id:project?.client_id||'',
    manager_id:project?.manager_id||'',
    tipologie:project?.tipologie||[],
    regia:project?.regia||'',
    location:project?.location||'',
    notes:project?.notes||'',
    status:project?.status||'draft',
    revenue:project?.revenue??'',
    revenue_notes:project?.revenue_notes||'',
    invoice_status:project?.invoice_status||'preventivo',
    required_roles:project?.required_roles?.length?project.required_roles:[...ROLES],
    budget_logistica:project?.budget_logistica??'',
    budget_benzina:project?.budget_benzina??'',
    budget_manutenzione:project?.budget_manutenzione??'',
    budget_varie:project?.budget_varie??'',
    budget_note:project?.budget_note||'',
  });
  const s=k=>e=>setF(p=>({...p,[k]:e.target.value}));
  const dur=f.date_start&&f.date_end?
    Math.max(1,Math.round((new Date(f.date_end)-new Date(f.date_start))/86400000)+1):null;

  const saveClient=async()=>{
    if(!ncn.trim())return;
    const slug=ncn.trim().toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
    const c=await api('/clients','POST',{name:ncn.trim(),slug});
    setCl(p=>[...p,c]);setF(p=>({...p,client_id:c.id}));setNcn('');setNcm(false);
  };

  const toggleR=r=>setF(p=>({...p,required_roles:p.required_roles.includes(r)
    ?p.required_roles.filter(x=>x!==r):[...p.required_roles,r]}));

  const submit=async()=>{
    if(!f.title.trim()){setErr('Titolo obbligatorio');return;}
    if(!f.date_start){setErr('Data inizio obbligatoria');return;}
    setErr('');setSaving(true);
    const body={
      title:f.title.trim(),date_start:f.date_start,
      date_end:f.date_end||f.date_start,
      client_id:f.client_id?+f.client_id:null,
      manager_id:f.manager_id?+f.manager_id:null,
      tipologie:f.tipologie?.length?f.tipologie:null,regia:f.regia||null,
      location:f.location||null,notes:f.notes||null,
      status:f.status,required_roles:f.required_roles,
      revenue:+(f.revenue||0),revenue_notes:f.revenue_notes||null,
      invoice_status:f.invoice_status,
      budget_logistica:+(f.budget_logistica||0),
      budget_benzina:+(f.budget_benzina||0),
      budget_manutenzione:+(f.budget_manutenzione||0),
      budget_varie:+(f.budget_varie||0),
      budget_note:f.budget_note||null,
    };
    try{
      if(project?.id)await api(`/projects/${project.id}`,'PATCH',body);
      else await api('/projects','POST',body);
      onSave();
    }catch(e){setErr('Errore: '+e.message);}
    finally{setSaving(false);}
  };

  const FORM_TABS=[['info','Dati cantiere'],['team','Composizione team'],['commessa','Commessa'],['costi','Costi operativi']];

  return(
    <div>
      <Tabs tabs={FORM_TABS} active={tab} onChange={setTab}/>

      {tab==='info'&&(
        <div className="grid grid-2">
          <FG label="Nome produzione *" span={2}>
            <input className="input" value={f.title} onChange={s('title')} placeholder="es. Sant'Efisio 2026"/>
          </FG>
          <FG label="Data inizio *">
            <input type="date" className="input" value={f.date_start} onChange={s('date_start')}/>
          </FG>
          <FG label={`Data fine${dur?` (${dur} giorni)`:''}`}>
            <input type="date" className="input" value={f.date_end} onChange={s('date_end')} min={f.date_start}/>
          </FG>
          <FG label={<span style={{display:'flex',justifyContent:'space-between'}}>
            <span>Cliente</span>
            <span style={{cursor:'pointer',color:'var(--blue)',fontSize:11,display:'flex',alignItems:'center',gap:3}}
              onClick={()=>setNcm(true)}><Icon name="plus" size={10} color="var(--blue)"/>nuovo</span>
          </span>}>
            <select className="input" value={f.client_id} onChange={s('client_id')}>
              <option value="">- nessuno -</option>
              {cl.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </FG>
          <FG label="Responsabile cantiere">
            <select className="input" value={f.manager_id} onChange={s('manager_id')}>
              <option value="">- nessuno -</option>
              {techs.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </FG>
          <FG label="Tipologia" span={2}>
            <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
              {TIPOLOGIE.map(t=>{
                const on=(f.tipologie||[]).includes(t);
                return <span key={t} onClick={()=>setF(p=>({...p,
                  tipologie:on?(p.tipologie||[]).filter(x=>x!==t):[...(p.tipologie||[]),t]
                }))} style={{cursor:'pointer',
                  padding:'4px 10px',borderRadius:6,fontSize:11,fontWeight:on?600:400,
                  background:on?'var(--blue-50)':'var(--n50)',
                  border:on?'1.5px solid var(--blue)':'1.5px solid var(--border)',
                  color:on?'var(--blue-dark)':'var(--n400)',transition:'all .1s'}}>{t}</span>;
              })}
            </div>
          </FG>
          <FG label="Regia">
            <select className="input" value={f.regia} onChange={s('regia')}>
              <option value="">-</option>
              {REGIE.map(r=><option key={r}>{r}</option>)}
            </select>
          </FG>
          <FG label="Location" span={2}>
            <input className="input" value={f.location} onChange={s('location')} placeholder="Luogo / venue"/>
          </FG>
          <FG label="Stato">
            <select className="input" value={f.status} onChange={s('status')}>
              {STATUSES.map(st=><option key={st} value={st}>{SL[st]}</option>)}
            </select>
          </FG>
          <FG label="Note interne" span={2}>
            <textarea className="input" rows={2} value={f.notes} onChange={s('notes')}/>
          </FG>
        </div>
      )}

      {tab==='team'&&(
        <div>
          <p style={{fontSize:12,color:'var(--n400)',marginBottom:14}}>
            Seleziona i ruoli necessari. Puoi assegnare i tecnici dopo la creazione.
          </p>
          <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
            {ROLES.map(r=>{
              const on=f.required_roles.includes(r);
              return(
                <div key={r} onClick={()=>toggleR(r)} style={{
                  display:'flex',alignItems:'center',gap:5,padding:'6px 11px',
                  borderRadius:7,cursor:'pointer',fontSize:12,fontWeight:on?600:400,
                  border:on?'1.5px solid var(--blue)':'1.5px solid var(--border)',
                  background:on?'var(--blue-50)':'var(--n50)',
                  color:on?'var(--blue-dark)':'var(--n500)',transition:'all .1s',
                }}>
                  <Icon name={on?'check-circle':'circle'} size={12}
                    color={on?'var(--blue)':'var(--n300)'}/>
                  {RL[r]}
                </div>
              );
            })}
          </div>
          <div style={{marginTop:12,display:'flex',alignItems:'center',gap:10,fontSize:12,color:'var(--n400)'}}>
            <span style={{background:'var(--blue)',color:'#fff',borderRadius:20,
              padding:'2px 9px',fontSize:11,fontWeight:600}}>{f.required_roles.length}</span>
            ruoli selezionati su {ROLES.length}
            <button className="btn btn-ghost btn-sm" style={{marginLeft:'auto'}}
              onClick={()=>setF(p=>({...p,required_roles:[...ROLES]}))}>Tutti</button>
            <button className="btn btn-ghost btn-sm"
              onClick={()=>setF(p=>({...p,required_roles:[]}))}>Nessuno</button>
          </div>
        </div>
      )}

      {tab==='commessa'&&(
        <div className="grid grid-2">
          <FG label="Valore commessa (-)" span={2}>
            <input type="number" min="0" step="0.01" className="input"
              value={f.revenue} onChange={s('revenue')} placeholder="es. 8000"/>
          </FG>
          <FG label="Stato fatturazione">
            <select className="input" value={f.invoice_status} onChange={s('invoice_status')}>
              {INVOICE.map(i=><option key={i}>{i}</option>)}
            </select>
          </FG>
          <FG label="Note commessa">
            <input className="input" value={f.revenue_notes} onChange={s('revenue_notes')} placeholder="Rif. PO, contratto..."/>
          </FG>
          {f.revenue>0&&(
            <div style={{gridColumn:'span 2'}} className="budget-total">
              <div style={{fontSize:12,color:'var(--n400)',marginBottom:4}}>Valore inserito</div>
              <div style={{fontSize:22,fontWeight:700,color:'var(--blue)'}}>{fmt(f.revenue)}</div>
            </div>
          )}
        </div>
      )}

      {tab==='costi'&&(
        <div>
          <div className="grid grid-2">
            {[['budget_logistica','truck','Logistica'],
              ['budget_benzina','fuel','Benzina'],
              ['budget_manutenzione','wrench','Manutenzione'],
              ['budget_varie','package','Varie']
            ].map(([field,icon,label])=>(
              <FG key={field} label={<span style={{display:'flex',alignItems:'center',gap:4}}>
                <Icon name={icon} size={11} color="var(--n400)"/>{label} (-)</span>}>
                <input type="number" min="0" step="0.01" className="input" placeholder="0"
                  value={f[field]} onChange={e=>setF(p=>({...p,[field]:e.target.value}))}/>
              </FG>
            ))}
            <FG label="Note spese" span={2}>
              <textarea className="input" rows={2} value={f.budget_note}
                onChange={e=>setF(p=>({...p,budget_note:e.target.value}))}/>
            </FG>
          </div>
          <div className="budget-total">
            <div className="flex-between">
              <span style={{fontSize:13,color:'var(--n400)'}}>Totale spese operative</span>
              <span style={{fontWeight:700,color:'var(--blue)'}}>
                {fmt((+(f.budget_logistica)||0)+(+(f.budget_benzina)||0)+(+(f.budget_manutenzione)||0)+(+(f.budget_varie)||0))}
              </span>
            </div>
          </div>
        </div>
      )}

      {err&&<p style={{color:'#991B1B',fontSize:12,marginTop:10}}>{err}</p>}
      <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:20}}>
        <button className="btn btn-ghost" onClick={onClose} disabled={saving}>Annulla</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>
          {saving?<Spin/>:<Icon name="save" size={13} color="#fff"/>}
          {saving?'Salvataggio...':'Salva cantiere'}
        </button>
      </div>

      {ncm&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setNcm(false)}>
          <div className="modal" style={{width:380}}>
            <div className="flex-between" style={{marginBottom:16}}>
              <div className="modal-title">Nuovo cliente</div>
              <button className="btn btn-ghost btn-sm" onClick={()=>setNcm(false)}>
                <Icon name="x" size={14} color="var(--n500)"/></button>
            </div>
            <FG label="Nome / Organizzazione">
              <input autoFocus className="input" value={ncn}
                onChange={e=>setNcn(e.target.value)} onKeyDown={e=>e.key==='Enter'&&saveClient()}
                placeholder="es. RaiSardegna"/>
            </FG>
            <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:12}}>
              <button className="btn btn-ghost" onClick={()=>setNcm(false)}>Annulla</button>
              <button className="btn btn-primary" onClick={saveClient}>
                <Icon name="check" size={13} color="#fff"/>Crea</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// CREW PANEL
// ============================================================

export const CrewPanel =({project,onUpdate})=>{
  const [crew,      setCrew]      = React.useState([]);
  const [techs,     setTechs]     = React.useState([]);
  const [adding,    setAdding]    = React.useState(null);
  const [selT,      setSelT]      = React.useState('');
  const [rateOv,    setRateOv]    = React.useState('');
  const [warn,      setWarn]      = React.useState('');
  const [editLbl,   setEditLbl]   = React.useState(null);
  const [notifModal,setNotifModal]= React.useState(null); // {crew_id, name, url, email, phone}
  const [notifying, setNotifying] = React.useState(null);
  const [unavailSet, setUnavailSet] = React.useState(new Set());

  const load=()=>api(`/projects/${project.id}/crew`).then(c=>setCrew(c||[])).catch(()=>{});
  React.useEffect(()=>{load();api('/technicians').then(t=>setTechs(t||[])).catch(()=>{});},[project.id]);
  React.useEffect(()=>{
    if(!project.date_start)return;
    const m=new Date(project.date_start).getMonth()+1;
    const y=new Date(project.date_start).getFullYear();
    api(`/availability?month=${m}&year=${y}`).then(avail=>{
      const s0=dayN(project.date_start),e0=dayN(project.date_end||project.date_start);
      const blocked=new Set();
      (avail||[]).forEach(a=>{const d=dayN(a.day);if(d>=s0&&d<=e0&&(a.status==="unavailable"||a.status==="vacation"))blocked.add(a.technician_id);});
      setUnavailSet(blocked);
    }).catch(()=>{});
  },[project.id,project.date_start,project.date_end]);

  const assign=async()=>{
    if(!selT||!adding)return;
    try{
      const body={technician_id:+selT,role:adding};
      if(rateOv)body.daily_rate_override=+rateOv;
      const r=await api(`/projects/${project.id}/crew`,'POST',body);
      setWarn(r?.warning||'');
    }catch(e){setWarn(e.message);}
    setAdding(null);setSelT('');setRateOv('');load();onUpdate&&onUpdate();showToast('Tecnico assegnato','success');
  };

  const remove=async id=>{
    await api(`/projects/${project.id}/crew/${id}`,'DELETE');
    load();onUpdate&&onUpdate();
  };

  const saveLabel=async(id,v)=>{
    await api(`/projects/${project.id}/crew/${id}`,'PATCH',{custom_label:v?.trim()||null});
    setEditLbl(null);load();
  };

  // Genera magic link e mostra modal
  const sendNotify=async(c)=>{
    setNotifying(c.id);
    try{
      const r=await api(`/projects/${project.id}/crew/${c.id}/notify`,'POST');
      setNotifModal({
        crew_id:   c.id,
        name:      r.technician_name,
        email:     r.technician_email,
        phone:     c.phone,
        url:       r.magic_url,
        email_sent: r.email_sent,
        note:      r.note,
      });
      load(); onUpdate&&onUpdate();
    }catch(e){ setWarn(e.message); }
    finally{ setNotifying(null); }
  };

  // Copia URL negli appunti
  const copyUrl=async(url)=>{
    try{ await navigator.clipboard.writeText(url); }
    catch{ }
  };

  const slotMap={};
  (crew||[]).forEach(c=>{slotMap[c.role]=slotMap[c.role]||[];slotMap[c.role].push(c);});
  const roles=project.required_roles?.length?project.required_roles:ROLES;
  const availT=adding?techs.filter(t=>!unavailSet.has(t.id)&&(
    adding.startsWith('operatore')||adding.startsWith('audio')||
    adding.startsWith('assistente')||(t.roles||[]).includes(adding))
  ):techs;

  // Contatori stato
  const totale=crew.length;
  const confermati=crew.filter(c=>c.letter_status==='accepted').length;
  const inAttesa=crew.filter(c=>c.letter_status==='sent').length;
  const declinati=crew.filter(c=>c.letter_status==='declined').length;

  return(
    <div>
      {warn&&<div className="alert alert-warning" style={{marginBottom:10}}>{warn}</div>}

      {/* Barra stato invii */}
      {totale>0&&(
        <div style={{display:'flex',gap:16,padding:'8px 12px',background:'var(--n50)',
          borderRadius:8,marginBottom:14,fontSize:12,flexWrap:'wrap'}}>
          {[
            {dot:'#E5E7EB',label:'Non inviati',val:totale-confermati-inAttesa-declinati},
            {dot:'#F59E0B',label:'In attesa',val:inAttesa},
            {dot:'#10B981',label:'Confermati',val:confermati},
            {dot:'#EF4444',label:'Declinati',val:declinati},
          ].map(s=>(
            <div key={s.label} style={{display:'flex',alignItems:'center',gap:5}}>
              <span style={{width:8,height:8,borderRadius:'50%',background:s.dot,flexShrink:0}}/>
              <span style={{color:'var(--n400)'}}>{s.label}:</span>
              <span style={{fontWeight:700,color:'var(--n700)'}}>{s.val}</span>
            </div>
          ))}
          {/* Pulsante "Notifica tutti non inviati" */}
          {crew.filter(c=>!c.letter_status||c.letter_status==='draft').length>0&&(
            <button className="btn btn-primary btn-sm" style={{marginLeft:'auto',fontSize:11}}
              onClick={()=>{
                const nonInviati=crew.filter(c=>!c.letter_status||c.letter_status==='draft');
                if(confirm(`Inviare notifica a ${nonInviati.length} tecnici non ancora notificati?`)){
                  nonInviati.forEach(c=>sendNotify(c));
                }
              }}>
              <Icon name="send" size={11} color="#fff"/>
              Notifica tutti ({crew.filter(c=>!c.letter_status||c.letter_status==='draft').length})
            </button>
          )}
        </div>
      )}

      {roles.map(role=>{
        const ass=slotMap[role]||[];
        const isAdd=adding===role;
        return(
          <div key={role} style={{borderBottom:'1px solid var(--n100)',padding:'8px 0',
            display:'flex',alignItems:'flex-start',gap:8,flexWrap:'wrap'}}>

            {/* Nome ruolo */}
            <div style={{width:115,flexShrink:0,fontSize:10,color:'var(--n400)',
              textTransform:'uppercase',letterSpacing:'.05em',paddingTop:6,fontWeight:700}}>
              {RL[role]}
            </div>

            {/* Tecnici assegnati */}
            <div style={{flex:1,display:'flex',flexWrap:'wrap',gap:4,alignItems:'center'}}>
              {ass.map(c=>(
                <div key={c.id} style={{display:'inline-flex',alignItems:'center',gap:5,
                  background:'var(--n0)',border:'1.5px solid var(--n200)',
                  borderRadius:10,padding:'4px 10px',fontSize:12,
                  boxShadow:'0 1px 3px rgba(0,0,0,.04)'}}>

                  {/* Semaforo */}
                  <StatusDot status={c.letter_status}/>

                  {/* Nome + etichetta modificabile */}
                  {editLbl?.id===c.id?(
                    <span style={{display:'flex',alignItems:'center',gap:4}}>
                      <input autoFocus className="input"
                        style={{width:120,padding:'2px 6px',fontSize:11,height:24}}
                        value={editLbl.v} placeholder={c.technician_name}
                        onChange={e=>setEditLbl(p=>({...p,v:e.target.value}))}
                        onKeyDown={e=>{if(e.key==='Enter')saveLabel(c.id,editLbl.v);
                          if(e.key==='Escape')setEditLbl(null);}}/>
                      <button onClick={()=>saveLabel(c.id,editLbl.v)}
                        style={{background:'none',border:'none',cursor:'pointer',padding:0}}>
                        <Icon name="check" size={11} color="#065F46"/></button>
                      <button onClick={()=>setEditLbl(null)}
                        style={{background:'none',border:'none',cursor:'pointer',padding:0}}>
                        <Icon name="x" size={10} color="var(--n400)"/></button>
                    </span>
                  ):(
                    <span style={{cursor:'pointer',display:'flex',alignItems:'center',gap:5}}
                      onClick={()=>setEditLbl({id:c.id,v:c.custom_label||''})}>
                      {c.custom_label?
                        <><span style={{color:'var(--blue)',fontWeight:600,fontSize:12}}>
                            {c.custom_label}</span>
                          <span style={{color:'var(--n400)',fontSize:10}}>
                            ({c.technician_name})</span></>:
                        <span style={{fontWeight:600}}>{c.technician_name}</span>}
                      {(c.daily_rate_effective||c.daily_rate)>0&&
                        <span style={{fontSize:10,color:'#B87D00',fontWeight:600}}>
                          {fmt(c.daily_rate_effective||c.daily_rate)}</span>}
                      <Icon name="pencil" size={9} color="var(--n300)" style={{opacity:.4}}/>
                    </span>
                  )}

                  {/* Badge tipo + Email disponibile */}
                  <span className={`emp-badge emp-${c.employment_type||'freelance'}`}
                    style={{fontSize:9,padding:'1px 5px'}}>{c.employment_type}</span>
                  {c.email&&<Icon name="mail" size={10} color="#10B981" style={{opacity:.7}}
                    title={c.email}/>}

                  {/* Pulsante notifica */}
                  {c.letter_status!=='accepted'&&c.letter_status!=='declined'&&(
                    <button title={c.letter_status==='sent'?'Reinvia notifica':'Invia notifica al tecnico'}
                      style={{background:c.letter_status==='sent'?'#FEF3C7':'#DBEAFE',
                        border:'none',borderRadius:6,padding:'2px 6px',cursor:'pointer',
                        display:'flex',alignItems:'center',gap:3,
                        color:c.letter_status==='sent'?'#92400E':'#1D4ED8',fontSize:10,fontWeight:600}}
                      onClick={e=>{e.stopPropagation();sendNotify(c);}}
                      disabled={notifying===c.id}>
                      {notifying===c.id
                        ? <Icon name="loader" size={10} color="currentColor"
                            style={{animation:'spin 1s linear infinite'}}/>
                        : <Icon name="send" size={10} color="currentColor"/>}
                      {c.letter_status==='sent'?'Rinvia':'Notifica'}
                    </button>
                  )}

                  {/* Stato confermato/declinato */}
                  {c.letter_status==='accepted'&&(
                    <span style={{fontSize:10,color:'#065F46',fontWeight:700,
                      display:'flex',alignItems:'center',gap:2}}>
                      <Icon name="check-circle" size={10} color="#10B981"/>
                      {c.confirmed_at ? 'il '+c.confirmed_at.split('T')[0].split('-').reverse().join('/') : 'confermato'}
                    </span>
                  )}
                  {c.letter_status==='declined'&&(
                    <span style={{fontSize:10,color:'#991B1B',fontWeight:700,
                      display:'flex',alignItems:'center',gap:2}}>
                      <Icon name="x-circle" size={10} color="#EF4444"/>declinato
                    </span>
                  )}

                  {/* Rimuovi */}
                  <button onClick={()=>remove(c.id)}
                    style={{background:'none',border:'none',cursor:'pointer',padding:0,lineHeight:1,
                      marginLeft:2}}>
                    <Icon name="x" size={10} color="var(--blue)"/></button>
                </div>
              ))}

              {/* Form aggiunta tecnico */}
              {isAdd?(
                <div style={{display:'flex',alignItems:'center',gap:4,flexWrap:'wrap',marginTop:2}}>
                  <select autoFocus className="input"
                    style={{width:170,fontSize:12,padding:'4px 8px',height:30}}
                    value={selT} onChange={e=>setSelT(e.target.value)}>
                    <option value="">- tecnico -</option>
                    {availT.map(t=><option key={t.id} value={t.id}>
                      {t.name} ({t.employment_type}){t.daily_rate>0?' - '+fmt(t.daily_rate)+'/g':''}
                    </option>)}
                  </select>
                  <input type="number" className="input" placeholder="Override -/g"
                    style={{width:120,fontSize:12,padding:'4px 8px',height:30}}
                    value={rateOv} onChange={e=>setRateOv(e.target.value)}/>
                  <button className="btn btn-primary btn-sm" onClick={assign} disabled={!selT}>
                    <Icon name="check" size={11} color="#fff"/>OK</button>
                  <button className="btn btn-ghost btn-sm"
                    onClick={()=>{setAdding(null);setSelT('');setRateOv('');}}>
                    <Icon name="x" size={11} color="var(--n500)"/></button>
                </div>
              ):(
                <button className="btn btn-ghost btn-sm"
                  style={{fontSize:11,padding:'3px 8px'}}
                  onClick={()=>{setAdding(role);setSelT('');}}>
                  <Icon name="plus" size={11} color="var(--n500)"/>Assegna</button>
              )}
            </div>
          </div>
        );
      })}

      {/* Modal link notifica */}
      {notifModal&&(
        <Modal title="Notifica inviata" onClose={()=>setNotifModal(null)}>
          <div style={{marginBottom:16}}>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12,
              padding:'12px 14px',background:'#D1FAE5',borderRadius:10,
              border:'1px solid #6EE7B7'}}>
              <Icon name="check-circle" size={18} color="#065F46"/>
              <div>
                <div style={{fontWeight:700,color:'#065F46'}}>{notifModal.name}</div>
                <div style={{fontSize:12,color:'#065F46',marginTop:2}}>
                  {notifModal.email_sent ? 'Email inviata automaticamente' : 'Notifica creata nel portale'}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Link di accesso portale (valido 7 giorni)</label>
              <div style={{display:'flex',gap:6}}>
                <input className="input" readOnly value={notifModal.url}
                  style={{fontSize:11,background:'var(--n50)'}}/>
                <button className="btn btn-ghost btn-sm" style={{flexShrink:0,whiteSpace:'nowrap'}}
                  onClick={()=>copyUrl(notifModal.url)}>
                  <Icon name="copy" size={12} color="var(--n500)"/>Copia</button>
              </div>
            </div>

            <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:4}}>
              {notifModal.phone&&(
                <a href={`https://wa.me/${notifModal.phone.replace(/\D/g,'')}?text=${encodeURIComponent('Ciao! Puoi accedere al portale EjaTV per vedere i dettagli del cantiere e confermare la tua disponibilita: '+notifModal.url)}`}
                  target="_blank" rel="noopener"
                  style={{display:'inline-flex',alignItems:'center',gap:6,
                    padding:'8px 14px',background:'#25D366',color:'#fff',
                    borderRadius:8,fontSize:13,fontWeight:600,textDecoration:'none'}}>
                  <Icon name="message-circle" size={14} color="#fff"/>WhatsApp
                </a>
              )}
              {notifModal.email&&(
                <a href={`mailto:${notifModal.email}?subject=Portale EjaTV - Accesso cantiere&body=Ciao! Accedi al portale EjaTV per vedere i dettagli del cantiere: ${notifModal.url}`}
                  style={{display:'inline-flex',alignItems:'center',gap:6,
                    padding:'8px 14px',background:'#1D4ED8',color:'#fff',
                    borderRadius:8,fontSize:13,fontWeight:600,textDecoration:'none'}}>
                  <Icon name="mail" size={14} color="#fff"/>Email
                </a>
              )}
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end'}}>
            <button className="btn btn-primary" onClick={()=>setNotifModal(null)}>
              <Icon name="check" size={13} color="#fff"/>Chiudi</button>
          </div>
        </Modal>
      )}
    </div>
  );
};


// ============================================================
// BUDGET PANEL (nel drawer)
// ============================================================

export const BudgetPanel =({project,onEditClick})=>{
  const [b,setB]=React.useState(null);
  React.useEffect(()=>{
    api(`/projects/${project.id}/budget`).then(setB).catch(()=>setB(null));
  },[project.id]);
  if(!b)return<div style={{padding:20,color:'var(--n400)',fontSize:12}}><Spin/> Caricamento budget...</div>;

  return(
    <div>
      <div className="budget-total" style={{marginBottom:20}}>
        <div className="flex-between" style={{marginBottom:8}}>
          <div>
            <div style={{fontSize:11,color:'var(--n400)',marginBottom:2}}>Revenue commessa</div>
            <div style={{fontSize:22,fontWeight:700,color:b.revenue>0?'#065F46':'var(--n300)'}}>
              {b.revenue>0?fmt(b.revenue):'Non inserita'}
            </div>
          </div>
          <div style={{textAlign:'right'}}>
            <div style={{fontSize:11,color:'var(--n400)',marginBottom:2}}>Margine netto</div>
            <div style={{fontSize:20,fontWeight:700,
              color:b.margine_netto>=0?'#065F46':'#991B1B'}}>
              {fmt(b.margine_netto)}
              {b.margine_pct!=null&&
                <span style={{fontSize:13,marginLeft:6}}>({b.margine_pct}%)</span>}
            </div>
          </div>
        </div>
        <div style={{fontSize:11,color:'var(--n400)',display:'flex',gap:16,flexWrap:'wrap'}}>
          <span>Crew: {fmt(b.crew_cost)}</span>
          <span>Spese: {fmt(b.spese_operative)}</span>
          <span>Tot. costi: {fmt(b.costo_totale)}</span>
        </div>
      </div>

      <div style={{fontSize:11,color:'var(--n400)',textTransform:'uppercase',
        letterSpacing:'.06em',marginBottom:8,fontWeight:700}}>
        Crew ({b.crew_count} tecnici)
      </div>
      {(b.crew_detail||[]).map((c,i)=>(
        <div key={i} className="budget-row" style={{padding:'5px 0'}}>
          <span style={{fontSize:12,color:'var(--n600)',display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:10,color:'var(--n400)',width:90,flexShrink:0}}>{RL[c.role]||c.role}</span>
            <span style={{fontWeight:500}}>{c.technician_name}</span>
            <span className={`emp-badge emp-${c.employment_type||'freelance'}`}
              style={{fontSize:9}}>{c.employment_type}</span>
          </span>
          <span style={{fontSize:12,fontWeight:600,color:c.daily_rate_effective>0?'#B87D00':'var(--n400)'}}>
            {c.daily_rate_effective>0?fmt(c.daily_rate_effective):'-'}</span>
        </div>
      ))}
      {!b.crew_detail?.length&&<div style={{fontSize:12,color:'var(--n400)',marginBottom:12}}>Nessun tecnico assegnato</div>}

      {b.spese_operative>0&&(
        <>
          <div style={{fontSize:11,color:'var(--n400)',textTransform:'uppercase',
            letterSpacing:'.06em',margin:'12px 0 8px',fontWeight:700}}>Spese operative</div>
          {[['Logistica',b.budget_logistica],['Benzina',b.budget_benzina],
            ['Manutenzione',b.budget_manutenzione],['Varie',b.budget_varie]]
            .filter(([,v])=>v>0).map(([l,v])=>(
              <div key={l} className="budget-row" style={{padding:'5px 0'}}>
                <span style={{fontSize:12,color:'var(--n600)'}}>{l}</span>
                <span style={{fontSize:12,fontWeight:600}}>{fmt(v)}</span>
              </div>
          ))}
        </>
      )}
      <button style={{marginTop:12,fontSize:11,color:'var(--blue)',
        display:'inline-flex',alignItems:'center',gap:4,
        background:'none',border:'none',cursor:'pointer',padding:0}}
        onClick={onEditClick}>
        <Icon name="pencil" size={10} color="var(--blue)"/>modifica commessa e costi
      </button>
    </div>
  );
};

// ============================================================
// DOCUMENTS PANEL
// ============================================================

export const DocsPanel =({project})=>{
  const [docs,setDocs]=React.useState([]);
  const [m,setM]=React.useState(false);
  const [gm,setGm]=React.useState(false);
  const [crew,setCrew]=React.useState([]);
  const [templates,setTemplates]=React.useState([]);
  const [f,setF]=React.useState({type:'brief',title:'',content:'',visibility:'admin'});
  const [gf,setGf]=React.useState({crew_id:'',template_id:'',custom_instructions:''});
  const [gr,setGr]=React.useState(null);
  const [gen,setGen]=React.useState(false);
  const [sav,setSav]=React.useState(false);
  // Upload template states
  const [uploadMode,setUploadMode]=React.useState(false);
  const [uploading,setUploading]=React.useState(false);
  const [uploadResult,setUploadResult]=React.useState(null);
  const fileRef=React.useRef(null);

  const load=()=>{api(`/projects/${project.id}/documents`).then(setDocs).catch(()=>{})};
  React.useEffect(()=>{
    load();
    api(`/projects/${project.id}/crew`).then(setCrew).catch(()=>{});
    api('/letter-templates').then(setTemplates).catch(()=>{});
  },[project.id]);

  const save=async()=>{
    if(!f.title.trim())return;
    setSav(true);
    try{await api(`/projects/${project.id}/documents`,'POST',{project_id:project.id,...f,content:f.content||null});
      setM(false);setF({type:'brief',title:'',content:'',visibility:'admin'});load();}
    catch(e){/* toast globale */}finally{setSav(false);}
  };

  const genLetter=async()=>{
    if(!gf.crew_id)return;
    setGen(true);
    try{
      const body={crew_id:+gf.crew_id, custom_instructions:gf.custom_instructions||null};
      if(gf.template_id) body.template_id=+gf.template_id;
      const r=await api(`/projects/${project.id}/letters/generate`,'POST',body);
      setGr(r);load();
    }
    catch(e){alert('Errore: '+e.message);}
    finally{setGen(false);}
  };

  const uploadTemplate=async(file)=>{
    if(!file)return;
    setUploading(true);
    try{
      const fd=new FormData();
      fd.append('file',file);
      fd.append('auto_tag','true');
      const r=await fetch('/api/letter-templates/upload',{method:'POST',body:fd});
      if(!r.ok)throw new Error(await r.text());
      const data=await r.json();
      setUploadResult(data);
      api('/letter-templates').then(setTemplates).catch(()=>{});
    }catch(e){alert('Errore upload: '+e.message);}
    finally{setUploading(false);}
  };

  const typeIcon={brief:'file-text',lettera_incarico:'file-check',rundown:'list-ordered',
    tecnico:'settings',allegato:'paperclip',contratto:'scroll'};
  const typeColor={lettera_incarico:'#065F46',brief:'#1D4ED8',contratto:'#92400E',rundown:'var(--blue)'};

  return(
    <div>
      <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginBottom:12}}>
        <button className="btn btn-ghost btn-sm" onClick={()=>setGm(true)}>
          <Icon name="wand-2" size={12} color="var(--n500)"/>Genera lettera
        </button>
        <button className="btn btn-primary btn-sm" onClick={()=>setM(true)}>
          <Icon name="plus" size={12} color="#fff"/>Documento
        </button>
      </div>

      {docs.map(d=>(
        <div key={d.id} className="crew-slot" style={{marginBottom:6}}>
          <Icon name={typeIcon[d.type]||'file'} size={14} color={typeColor[d.type]||'var(--n400)'}/>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:13}}>{d.title}</div>
            <div style={{fontSize:11,color:'var(--n400)',display:'flex',gap:8,marginTop:2}}>
              <span>{d.type}</span>
              <span style={{color:d.visibility==='operatore'?'#065F46':'var(--n400)'}}>
                {d.visibility==='operatore'?'tecnici':d.visibility==='responsabile'?'responsabile':'admin'}</span>
              {d.generated_by==='llm'&&<span style={{color:'#1D4ED8',display:'flex',alignItems:'center',gap:2}}>
                <Icon name="sparkles" size={9} color="#1D4ED8"/>AI</span>}
            </div>
          </div>
          <span style={{fontSize:10,color:'var(--n400)'}}>{fmtD(d.created_at)}</span>
        </div>
      ))}
      {!docs.length&&<div className="empty" style={{padding:30}}>Nessun documento</div>}

      {/* Modal nuovo documento */}
      {m&&(
        <Modal title="Nuovo documento" onClose={()=>setM(false)}>
          <div className="grid grid-2">
            <FG label="Tipo">
              <select className="input" value={f.type} onChange={e=>setF(p=>({...p,type:e.target.value}))}>
                {['brief','lettera_incarico','rundown','tecnico','allegato','contratto'].map(t=><option key={t}>{t}</option>)}
              </select>
            </FG>
            <FG label="Visibilita">
              <select className="input" value={f.visibility} onChange={e=>setF(p=>({...p,visibility:e.target.value}))}>
                <option value="admin">Solo amministrazione</option>
                <option value="responsabile">Responsabile cantiere</option>
                <option value="operatore">Visibile ai tecnici</option>
              </select>
            </FG>
            <FG label="Titolo *" span={2}>
              <input className="input" value={f.title} onChange={e=>setF(p=>({...p,title:e.target.value}))}/>
            </FG>
            <FG label="Contenuto" span={2}>
              <textarea className="input" rows={6} value={f.content}
                onChange={e=>setF(p=>({...p,content:e.target.value}))} placeholder="Testo..."/>
            </FG>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:12}}>
            <button className="btn btn-ghost" onClick={()=>setM(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={save} disabled={sav}>
              <Icon name="save" size={13} color="#fff"/>{sav?'Salvataggio...':'Salva'}</button>
          </div>
        </Modal>
      )}

      {/* Modal genera lettera */}
      {gm&&(
        <Modal title="Genera lettera di incarico" onClose={()=>{setGm(false);setGr(null);setUploadMode(false);setUploadResult(null);}}>
          {!gr?(
            <div>
              {/* Tab: Genera / Carica template */}
              <div style={{display:'flex',gap:0,borderBottom:'2px solid var(--n100)',marginBottom:16}}>
                <button onClick={()=>{setUploadMode(false);setUploadResult(null);}}
                  style={{padding:'8px 16px',fontSize:13,fontWeight:!uploadMode?600:400,
                    color:!uploadMode?'var(--blue)':'var(--n400)',background:'none',border:'none',
                    cursor:'pointer',borderBottom:!uploadMode?'2px solid var(--blue)':'2px solid transparent',
                    marginBottom:-2}}>
                  <Icon name="wand-2" size={12} color={!uploadMode?'var(--blue)':'var(--n400)'} style={{marginRight:6}}/>
                  Genera da template
                </button>
                <button onClick={()=>setUploadMode(true)}
                  style={{padding:'8px 16px',fontSize:13,fontWeight:uploadMode?600:400,
                    color:uploadMode?'var(--blue)':'var(--n400)',background:'none',border:'none',
                    cursor:'pointer',borderBottom:uploadMode?'2px solid var(--blue)':'2px solid transparent',
                    marginBottom:-2}}>
                  <Icon name="upload" size={12} color={uploadMode?'var(--blue)':'var(--n400)'} style={{marginRight:6}}/>
                  Carica template Word
                </button>
              </div>

              {!uploadMode?(
                <div>
                  {/* Selezione template */}
                  <FG label="Template lettera">
                    <select className="input" value={gf.template_id}
                      onChange={e=>setGf(p=>({...p,template_id:e.target.value}))}>
                      {templates.map(t=><option key={t.id} value={t.id}>
                        {t.name} {t.source_file?'(da Word)':''}
                      </option>)}
                    </select>
                  </FG>

                  {/* Info template selezionato */}
                  {gf.template_id && (() => {
                    const sel = templates.find(t=>t.id===+gf.template_id);
                    const vars = sel?.variables || [];
                    const varList = typeof vars === 'string' ? JSON.parse(vars) : vars;
                    return sel ? (
                      <div style={{padding:'10px 12px',background:'var(--n50)',borderRadius:8,
                        marginBottom:12,fontSize:11,color:'var(--n400)'}}>
                        <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                          {varList.map(v=>(
                            <span key={v} style={{background:'var(--blue-50)',color:'var(--blue)',
                              padding:'2px 7px',borderRadius:4,fontSize:10,fontWeight:500,
                              border:'1px solid var(--blue-pale)'}}>
                              {'{{'}{v}{'}}'}
                            </span>
                          ))}
                        </div>
                        {sel.source_file&&<div style={{marginTop:6,fontSize:10}}>
                          <Icon name="file" size={9} color="var(--n300)" style={{marginRight:3}}/>
                          Sorgente: {sel.source_file}
                        </div>}
                      </div>
                    ) : null;
                  })()}

                  <FG label="Tecnico destinatario *">
                    <select className="input" value={gf.crew_id}
                      onChange={e=>setGf(p=>({...p,crew_id:e.target.value}))}>
                      <option value="">- seleziona tecnico assegnato -</option>
                      {crew.map(c=><option key={c.id} value={c.id}>
                        {c.technician_name} - {RL[c.role]||c.role}
                      </option>)}
                    </select>
                  </FG>
                  <FG label="Istruzioni aggiuntive (opzionale)">
                    <textarea className="input" rows={2} value={gf.custom_instructions}
                      onChange={e=>setGf(p=>({...p,custom_instructions:e.target.value}))}
                      placeholder="es. Aggiungi clausola riservatezza, cambia tono formale..."/>
                  </FG>
                  <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:16}}>
                    <button className="btn btn-ghost" onClick={()=>setGm(false)}>Annulla</button>
                    <button className="btn btn-primary" onClick={genLetter}
                      disabled={gen||!gf.crew_id}>
                      {gen?<Spin/>:<Icon name="wand-2" size={13} color="#fff"/>}
                      {gen?'Generazione...':'Genera lettera'}
                    </button>
                  </div>
                </div>
              ):(
                /* Upload template Word */
                <div>
                  {!uploadResult?(
                    <div>
                      <div style={{border:'2px dashed var(--n200)',borderRadius:12,padding:'32px 24px',
                        textAlign:'center',marginBottom:16,background:'var(--n50)',
                        cursor:'pointer',transition:'border-color .15s'}}
                        onClick={()=>fileRef.current?.click()}
                        onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--blue)';}}
                        onDragLeave={e=>{e.currentTarget.style.borderColor='var(--n200)';}}
                        onDrop={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--n200)';
                          const file=e.dataTransfer.files[0];if(file)uploadTemplate(file);}}>
                        {uploading?(
                          <div>
                            <Spin/>
                            <div style={{marginTop:10,fontSize:13,color:'var(--n500)'}}>
                              Claude sta analizzando il documento e inserendo i tag...
                            </div>
                          </div>
                        ):(
                          <div>
                            <Icon name="upload-cloud" size={32} color="var(--n300)" style={{margin:'0 auto 10px'}}/>
                            <div style={{fontSize:14,fontWeight:600,color:'var(--n600)',marginBottom:4}}>
                              Trascina un file .docx o clicca per selezionare
                            </div>
                            <div style={{fontSize:12,color:'var(--n400)'}}>
                              Claude identifichera nomi, date, importi e inserira i tag automaticamente
                            </div>
                          </div>
                        )}
                      </div>
                      <input ref={fileRef} type="file" accept=".docx" style={{display:'none'}}
                        onChange={e=>{const file=e.target.files[0];if(file)uploadTemplate(file);e.target.value='';}}/>

                      <div style={{padding:12,background:'var(--blue-50)',borderRadius:8,
                        fontSize:12,color:'var(--blue-dark)',display:'flex',alignItems:'flex-start',gap:8}}>
                        <Icon name="info" size={14} color="var(--blue)" style={{flexShrink:0,marginTop:1}}/>
                        <div>
                          <div style={{fontWeight:600,marginBottom:4}}>Come funziona</div>
                          Carica una lettera di incarico gia compilata (con nomi e dati reali).
                          Claude la analizza e sostituisce i valori con variabili come
                          {' '}{'{{'}nome_operatore{'}}'},  {'{{'}data_inizio{'}}'},  {'{{'}compenso_totale{'}}'}.
                          Il template diventa riutilizzabile per qualsiasi tecnico e cantiere.
                        </div>
                      </div>
                    </div>
                  ):(
                    /* Upload result preview */
                    <div>
                      <div style={{background:'#D1FAE5',border:'1px solid #6EE7B7',color:'#065F46',
                        padding:'10px 14px',borderRadius:8,marginBottom:12,fontSize:13,
                        display:'flex',alignItems:'center',gap:8}}>
                        <Icon name="check-circle" size={14} color="#065F46"/>
                        Template "{uploadResult.name}" creato con {uploadResult.detected_variables?.length||0} variabili
                      </div>

                      {/* Variables detected */}
                      <div style={{marginBottom:12}}>
                        <div style={{fontSize:11,color:'var(--n400)',fontWeight:700,
                          textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}>
                          Variabili rilevate
                        </div>
                        <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                          {(uploadResult.detected_variables||[]).map(v=>(
                            <span key={v} style={{background:'var(--blue-50)',color:'var(--blue)',
                              padding:'3px 8px',borderRadius:5,fontSize:11,fontWeight:500,
                              border:'1px solid var(--blue-pale)'}}>
                              {'{{'}{v}{'}}'}
                            </span>
                          ))}
                          {!(uploadResult.detected_variables||[]).length&&
                            <span style={{fontSize:12,color:'var(--warn)'}}>
                              Nessuna variabile rilevata. Puoi modificare il template manualmente.
                            </span>}
                        </div>
                      </div>

                      {/* Preview */}
                      <div style={{fontFamily:'monospace',fontSize:11,background:'var(--n50)',
                        border:'1px solid var(--n200)',borderRadius:8,padding:14,
                        whiteSpace:'pre-wrap',maxHeight:220,overflowY:'auto',lineHeight:1.6}}>
                        {uploadResult.content}
                      </div>

                      <div style={{display:'flex',justifyContent:'space-between',marginTop:16,gap:8}}>
                        <button className="btn btn-ghost" onClick={()=>{setUploadResult(null);}}>
                          <Icon name="upload" size={12} color="var(--n500)"/>Carica un altro
                        </button>
                        <button className="btn btn-primary" onClick={()=>{
                          setUploadResult(null);setUploadMode(false);
                          setGf(p=>({...p,template_id:String(uploadResult.id)}));
                        }}>
                          <Icon name="wand-2" size={13} color="#fff"/>Usa questo template
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ):(
            /* Letter generated result */
            <div>
              <div style={{background:'#D1FAE5',border:'1px solid #6EE7B7',color:'#065F46',
                padding:'10px 14px',borderRadius:8,marginBottom:16,fontSize:13,
                display:'flex',alignItems:'center',gap:8}}>
                <Icon name="check-circle" size={14} color="#065F46"/>Lettera generata e salvata
              </div>
              <div style={{fontFamily:'monospace',fontSize:12,background:'var(--n50)',
                border:'1px solid var(--n200)',borderRadius:8,padding:16,
                whiteSpace:'pre-wrap',maxHeight:280,overflowY:'auto',lineHeight:1.7}}>
                {gr.document?.content}
              </div>
              <div style={{marginTop:8,fontSize:11,color:'var(--n400)'}}>
                Link portale: {gr.portal_url}
              </div>
              <div style={{display:'flex',justifyContent:'flex-end',marginTop:16}}>
                <button className="btn btn-primary" onClick={()=>{setGm(false);setGr(null);}}>
                  <Icon name="check" size={13} color="#fff"/>Chiudi</button>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
};


// ============================================================
// MESSAGES PANEL
// ============================================================

export const MsgsPanel =({project})=>{
  const [msgs,setMsgs]=React.useState([]);
  const [f,setF]=React.useState({subject:'',body:'',visibility:'admin'});
  const [sav,setSav]=React.useState(false);
  const load=()=>api(`/projects/${project.id}/messages`).then(setMsgs).catch(()=>{});
  React.useEffect(()=>{load()},[project.id]);
  const send=async()=>{
    if(!f.body.trim())return;setSav(true);
    try{await api(`/projects/${project.id}/messages`,'POST',{project_id:project.id,...f});
      setF({subject:'',body:'',visibility:'admin'});load();
      showToast('Messaggio inviato','success');}
    catch(e){/* toast globale */}
    finally{setSav(false);}
  };
  return(
    <div>
      <div className="card" style={{marginBottom:12,padding:'14px 16px'}}>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:8,alignItems:'center'}}>
          <label style={{margin:0,fontSize:12}}>Nuovo messaggio</label>
          <select className="input" style={{width:180,fontSize:11,padding:'3px 8px',height:26}}
            value={f.visibility} onChange={e=>setF(p=>({...p,visibility:e.target.value}))}>
            <option value="admin">Solo amministrazione</option>
            <option value="responsabile">Responsabile cantiere</option>
            <option value="operatore">Visibile ai tecnici</option>
          </select>
        </div>
        <input className="input" value={f.subject} style={{marginBottom:6}}
          onChange={e=>setF(p=>({...p,subject:e.target.value}))} placeholder="Oggetto (opzionale)"/>
        <textarea className="input" rows={3} value={f.body}
          onChange={e=>setF(p=>({...p,body:e.target.value}))} placeholder="Testo comunicazione..."/>
        <div style={{display:'flex',justifyContent:'flex-end',marginTop:8}}>
          <button className="btn btn-primary btn-sm" onClick={send} disabled={sav||!f.body.trim()}>
            <Icon name="send" size={12} color="#fff"/>{sav?'Invio...':'Invia'}
          </button>
        </div>
      </div>
      {msgs.map(m=>(
        <div key={m.id} style={{borderBottom:'1px solid var(--n100)',padding:'10px 0'}}>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
            <span style={{fontWeight:600,fontSize:13}}>{m.subject||'Comunicazione'}</span>
            <span style={{fontSize:10,color:'var(--n400)'}}>{fmtD(m.created_at)}</span>
          </div>
          <div style={{fontSize:13,color:'var(--n700)',lineHeight:1.6}}>{m.body}</div>
          <span style={{fontSize:10,color:m.visibility==='interno'?'var(--n400)':'#065F46'}}>
            {m.visibility==='operatore'?'tecnici':m.visibility==='responsabile'?'responsabile':'admin'}</span>
        </div>
      ))}
      {!msgs.length&&<div className="empty" style={{padding:20}}>Nessuna comunicazione</div>}
    </div>
  );
};

// ============================================================
// MATERIALS PANEL (dentro cantiere)
// ============================================================

export const MatsPanel =({project})=>{
  const [ass,setAss]=React.useState([]);
  const [all,setAll]=React.useState([]);
  const [m,setM]=React.useState(false);
  const [f,setF]=React.useState({material_id:'',quantity:1,date_out:'',date_in:'',notes:''});
  const [sav,setSav]=React.useState(false);
  const load=()=>{
    api(`/projects/${project.id}/materials`).then(setAss).catch(()=>{});
    api('/materials').then(setAll).catch(()=>{});
  };
  React.useEffect(()=>{load()},[project.id]);
  const assign=async()=>{
    if(!f.material_id)return;setSav(true);
    try{await api(`/projects/${project.id}/materials`,'POST',{material_id:+f.material_id,
      quantity:+f.quantity,date_out:f.date_out||null,date_in:f.date_in||null,notes:f.notes||null});
      setM(false);setF({material_id:'',quantity:1,date_out:'',date_in:'',notes:''});load();}
    catch(e){/* toast globale */}finally{setSav(false);}
  };
  const remove=async id=>{await api(`/projects/${project.id}/materials/${id}`,'DELETE');load();};
  const ci={camera:'camera',audio:'mic',regia:'monitor',veicolo:'truck',kit:'package',illuminazione:'zap',altro:'box'};

  return(
    <div>
      <div style={{display:'flex',justifyContent:'flex-end',marginBottom:12}}>
        <button className="btn btn-primary btn-sm" onClick={()=>setM(true)}>
          <Icon name="plus" size={12} color="#fff"/>Assegna materiale
        </button>
      </div>
      {ass.map(a=>(
        <div key={a.id} className="crew-slot" style={{marginBottom:6}}>
          <Icon name={ci[a.category]||'box'} size={14} color="var(--n400)"/>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:13}}>{a.material_name}</div>
            <div style={{fontSize:11,color:'var(--n400)',display:'flex',gap:8,marginTop:2}}>
              <span>{a.category}</span>
              {a.serial_number&&<span>SN:{a.serial_number}</span>}
              {a.date_out&&<span>Out:{fmtD(a.date_out)}</span>}
              {a.assigned_to_name&&<span> {a.assigned_to_name}</span>}
            </div>
          </div>
          <span style={{fontSize:11,color:'var(--n400)',marginRight:8}}>x{a.quantity}</span>
          <button className="btn btn-ghost btn-sm" onClick={()=>remove(a.id)} style={{padding:'4px 6px'}}>
            <Icon name="x" size={11} color="var(--blue)"/></button>
        </div>
      ))}
      {!ass.length&&<div className="empty" style={{padding:20}}>Nessun materiale assegnato</div>}
      {m&&(
        <Modal title="Assegna materiale" onClose={()=>setM(false)}>
          <div className="grid grid-2">
            <FG label="Materiale *" span={2}>
              <select className="input" value={f.material_id}
                onChange={e=>setF(p=>({...p,material_id:e.target.value}))}>
                <option value="">- seleziona -</option>
                {all.map(m=><option key={m.id} value={m.id}>[{m.category}] {m.name} - {m.status}</option>)}
              </select>
            </FG>
            <FG label="Quantita"><input type="number" min="1" className="input" value={f.quantity}
              onChange={e=>setF(p=>({...p,quantity:e.target.value}))}/></FG>
            <FG label="Note"><input className="input" value={f.notes}
              onChange={e=>setF(p=>({...p,notes:e.target.value}))}/></FG>
            <FG label="Data uscita"><input type="date" className="input" value={f.date_out}
              onChange={e=>setF(p=>({...p,date_out:e.target.value}))}/></FG>
            <FG label="Data rientro"><input type="date" className="input" value={f.date_in}
              onChange={e=>setF(p=>({...p,date_in:e.target.value}))}/></FG>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:12}}>
            <button className="btn btn-ghost" onClick={()=>setM(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={assign} disabled={sav}>
              <Icon name="check" size={13} color="#fff"/>Assegna</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ============================================================
// VEHICLES PANEL (mezzi nel cantiere)
// ============================================================

export const VehiclesPanel = ({project}) => {
  const [ass, setAss] = React.useState([]);
  const [all, setAll] = React.useState([]);
  const [m, setM] = React.useState(false);
  const [f, setF] = React.useState({vehicle_id:'',date_out:'',date_in:'',notes:''});
  const [sav, setSav] = React.useState(false);
  const [warn, setWarn] = React.useState('');
  const load = () => {
    api(`/projects/${project.id}/vehicles`).then(setAss).catch(()=>{});
    api('/vehicles?status=disponibile').then(d=>setAll(d||[])).catch(()=>setAll([]));
  };
  React.useEffect(() => { load(); }, [project.id]);

  const assign = async () => {
    if(!f.vehicle_id) return; setSav(true); setWarn('');
    try {
      const r = await api(`/projects/${project.id}/vehicles`,'POST',{
        vehicle_id:+f.vehicle_id,
        date_out:f.date_out||null, date_in:f.date_in||null,
        notes:f.notes||null});
      if(r?.warning) setWarn(r.warning);
      setM(false); setF({vehicle_id:'',date_out:'',date_in:'',notes:''}); load();
      showToast('Mezzo assegnato','success');
    } catch(e){}
    finally { setSav(false); }
  };

  const remove = async (pvId) => {
    await api(`/projects/${project.id}/vehicles/${pvId}`,'DELETE');
    load(); showToast('Mezzo rimosso','success');
  };

  return (
    <div>
      {warn&&<div className="alert alert-warning" style={{marginBottom:10}}>{warn}</div>}
      {ass.map(a => (
        <div key={a.id} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 0',
          borderBottom:'1px solid var(--n100)'}}>
          <Icon name="truck" size={16} color="var(--blue)"/>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:13}}>{a.vehicle_name}
              {a.plate&&<span style={{fontSize:11,color:'var(--n400)',marginLeft:6,fontFamily:'monospace'}}>{a.plate}</span>}
            </div>
            <div style={{fontSize:11,color:'var(--n400)'}}>
              {VT[a.vehicle_type]||a.vehicle_type}
              {a.daily_cost>0&&' · '+fmt(a.daily_cost)+'/g'}
              {a.date_out&&' · '+fmtD(a.date_out)}
              {a.date_in&&' → '+fmtD(a.date_in)}
              {a.assigned_to_name&&' · '+a.assigned_to_name}
            </div>
          </div>
          <button onClick={()=>remove(a.id)}
            style={{background:'none',border:'none',cursor:'pointer',padding:2}}>
            <Icon name="x" size={12} color="var(--n400)"/>
          </button>
        </div>
      ))}
      {!ass.length&&!m&&<div className="empty" style={{padding:20}}>Nessun mezzo assegnato</div>}

      {m ? (
        <div className="card" style={{marginTop:12,padding:'14px 16px'}}>
          <div className="grid grid-2">
            <FG label="Mezzo *" span={2}>
              <select className="input" value={f.vehicle_id} onChange={e=>setF({...f,vehicle_id:e.target.value})}>
                <option value="">— seleziona —</option>
                {all.map(v=><option key={v.id} value={v.id}>{v.name} {v.plate?'('+v.plate+')':''} — {VT[v.type]||v.type}</option>)}
              </select></FG>
            <FG label="Data uscita"><input type="date" className="input" value={f.date_out}
              onChange={e=>setF({...f,date_out:e.target.value})}/></FG>
            <FG label="Data rientro"><input type="date" className="input" value={f.date_in}
              onChange={e=>setF({...f,date_in:e.target.value})}/></FG>
            <FG label="Note" span={2}><input className="input" value={f.notes}
              onChange={e=>setF({...f,notes:e.target.value})}/></FG>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:10}}>
            <button className="btn btn-ghost btn-sm" onClick={()=>setM(false)}>Annulla</button>
            <button className="btn btn-primary btn-sm" onClick={assign} disabled={sav||!f.vehicle_id}>
              <Icon name="truck" size={12} color="#fff"/>{sav?'...':'Assegna'}</button>
          </div>
        </div>
      ) : (
        <button className="btn btn-ghost btn-sm" style={{marginTop:8}}
          onClick={()=>setM(true)}>
          <Icon name="plus" size={12}/>Assegna mezzo</button>
      )}
    </div>
  );
};


// ============================================================
// PROJECTS PAGE - layout con drawer
// ============================================================

export const ProjectsPage =({openId,initModal})=>{
  const [projects,setProjects]=React.useState([]);
  const [clients,setClients]=React.useState([]);
  const [techs,setTechs]=React.useState([]);
  const [sel,setSel]=React.useState(null);
  const [modal,setModal]=React.useState(initModal||null);
  const [drawerTab,setDrawerTab]=React.useState('info');
  const [ficGenerating,setFicGenerating]=React.useState(false);

  const changeStatus = async (newStatus) => {
    if(!sel || newStatus === sel.status) return;
    try {
      await api(`/projects/${sel.id}`, 'PATCH', {status: newStatus});
      const p = await api(`/projects/${sel.id}`);
      setSel(p);
      load();
      showToast(`Stato → ${newStatus}`, 'success');
    } catch(e) {}
  };

  const quickChangeStatus = async (pid, newStatus) => {
    try {
      await api(`/projects/${pid}`, 'PATCH', {status: newStatus});
      showToast(`Stato → ${SL[newStatus]||newStatus}`, 'success');
      load();
      // Se il cantiere aperto è quello modificato, aggiorna
      if(sel && sel.id === pid) {
        const p = await api(`/projects/${pid}`);
        setSel(p);
      }
    } catch(e) {}
  };

    const generateFicInvoice = async () => {
    if(!sel) return;
    if(!confirm('Generare bozza fattura in Fatture in Cloud?\n\nLa fattura sarà creata in stato BOZZA da rivedere e inviare dal pannello FiC.')) return;
    setFicGenerating(true);
    try {
      const r = await api(`/integrations/scan360/projects/${sel.id}/generate-invoice`, 'POST');
      showToast('Bozza fattura creata: #' + (r.fic_invoice_number||'?'), 'success');
      // Ricarica il cantiere aggiornato
      const p = await api(`/projects/${sel.id}`);
      setSel(p);
      load();
    } catch(e) {
    } finally {
      setFicGenerating(false);
    }
  };
  const [filterStatus,setFilterStatus]=React.useState('');
  const [search,setSearch]=React.useState('');
  const [offset,setOffset]=React.useState(0);
  const [total,setTotal]=React.useState(0);

  const load=()=>{
    let qs=`?limit=${PAGE_SIZE}&offset=${offset}`;
    if(filterStatus)qs+=`&status=${filterStatus}`;
    api(`/projects${qs}`).then(d=>{setProjects(d.items||d);setTotal(d.total||0);}).catch(()=>{});
    api('/clients').then(setClients).catch(()=>{});
    api('/technicians').then(setTechs).catch(()=>{});
  };
  React.useEffect(()=>{load();},[filterStatus,offset]);
  React.useEffect(()=>{setOffset(0);},[filterStatus]);
  React.useEffect(()=>{
    if(openId&&openId!=='new')api(`/projects/${openId}`).then(p=>{setSel(p);setDrawerTab('info');});
  },[openId]);

  const openP=async id=>{
    const p=await api(`/projects/${id}`);
    setSel(p);setDrawerTab('info');
  };
  const delP=async id=>{
    if(!confirm('Eliminare questo cantiere?'))return;
    await api(`/projects/${id}`,'DELETE');setSel(null);load();
  };

  const filtered=projects.filter(p=>!search||
    p.title?.toLowerCase().includes(search.toLowerCase())||
    p.code?.toLowerCase().includes(search.toLowerCase())||
    p.client_name?.toLowerCase().includes(search.toLowerCase())
  );

  const DRAWER_TABS=[['info','Info'],['crew','Team'],['budget','Budget'],
    ['docs','Documenti'],['msgs','Comunicazioni'],['mats','Attrezzature'],['veic','Mezzi']];

  return(
    <div>
      {/* Header */}
      <div className="page-header">
        <div>
          <div className="page-title">Cantieri</div>
          <div className="page-title-sub">{total} produzioni</div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <input className="input" style={{width:220}} placeholder="Cerca cantiere..."
            value={search} onChange={e=>setSearch(e.target.value)}/>
          <select className="input" style={{width:150}} value={filterStatus}
            onChange={e=>setFilterStatus(e.target.value)}>
            <option value="">Tutti gli stati</option>
            {ACTIVE_STATUSES.map(s=><option key={s} value={s}>{SL[s]}</option>)}
          </select>
          <button className="btn btn-primary" onClick={()=>setModal('new')}>
            <Icon name="plus" size={14} color="#fff"/>Nuovo
          </button>
        </div>
      </div>

      {/* Tabella */}
      <div className="card" style={{padding:0}}>
        <table>
          <thead>
            <tr>
              <th>Codice</th><th>Produzione</th><th>Date</th>
              <th>Cliente</th><th>Responsabile</th><th>Tipo</th>
              <th>Stato</th><th style={{textAlign:'right'}}>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p=>(
              <tr key={p.id} onClick={()=>openP(p.id)}
                style={{cursor:'pointer',background:sel?.id===p.id?'var(--blue-50)':''}}>
                <td>
                  <span style={{fontWeight:700,color:'var(--blue)',fontSize:12,
                    whiteSpace:'nowrap'}}>{p.code}</span>
                </td>
                <td style={{fontWeight:500,maxWidth:200}}>
                  <div style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{p.title}</div>
                </td>
                <td style={{fontSize:12,color:'var(--n400)',whiteSpace:'nowrap'}}>
                  {fmtD(p.date_start)}
                  {p.date_end&&p.date_end!==p.date_start&&<><br/><span style={{fontSize:10}}>  {fmtD(p.date_end)}</span></>}
                </td>
                <td style={{fontSize:12,color:'var(--n600)'}}>{p.client_name||'-'}</td>
                <td style={{fontSize:12,color:'var(--n600)'}}>{p.manager_name||'-'}</td>
                <td style={{fontSize:12}}>{(p.tipologie||[]).join(', ')||'-'}</td>
                <td onClick={e=>e.stopPropagation()}>
                  <StatusPicker value={p.status} options={STATUSES} labels={SL}
                    colors={STATUS_COLORS}
                    onChange={ns=>quickChangeStatus(p.id, ns)}/>
                </td>
                <td style={{textAlign:'right',fontWeight:600,color:'#065F46',fontSize:12}}>
                  {p.revenue>0?fmt(p.revenue):'-'}
                </td>
              </tr>
            ))}
            {!filtered.length&&(
              <tr><td colSpan={8} className="empty">
                {search?'Nessun cantiere trovato':'Nessun cantiere - creane uno'}
              </td></tr>
            )}
          </tbody>
        </table>
        <div style={{padding:'0 16px'}}>
          <Pagination total={total} limit={PAGE_SIZE} offset={offset} onChange={setOffset}/>
        </div>
      </div>

      {/* Modal dettaglio cantiere — centrale, 70% */}
      <LargeModal
        open={!!sel}
        onClose={()=>setSel(null)}
        title={sel?.title}
        subtitle={sel?.code}
        widthPct={70}
        actions={
          <div style={{display:'flex',gap:6}}>
            <button className="btn btn-ghost btn-sm" onClick={()=>setModal('edit')}>
              <Icon name="pencil" size={13} color="var(--n500)"/>Modifica</button>
            <button className="btn btn-ghost btn-sm" style={{color:'var(--blue-dark)'}}
              onClick={()=>delP(sel?.id)}>
              <Icon name="trash-2" size={13} color="var(--blue)"/>
            </button>
          </div>
        }
      >
        {sel&&(
          <>
            <Tabs tabs={DRAWER_TABS} active={drawerTab} onChange={setDrawerTab}/>

            {drawerTab==='info'&&(
              <div>
                {[
                  ['Codice',sel.code],
                  ['Stato',null,'status'],
                  ['Date',`${fmtD(sel.date_start)}${sel.date_end&&sel.date_end!==sel.date_start?'   '+fmtD(sel.date_end):''}`],
                  ['Cliente',sel.client_name],
                  ['Responsabile',sel.manager_name],
                  ['Tipologia',(sel.tipologie||[]).join(', ')],
                  ['Regia',sel.regia],
                  ['Location',sel.location],
                  ['Fatturazione',null,'invoice'],
                  ['Note',sel.notes],
                ].map(([k,v,special])=>{
                  if(!v&&!special)return null;
                  return(
                    <div key={k} style={{display:'flex',alignItems:'flex-start',
                      padding:'8px 0',borderBottom:'1px solid var(--n100)'}}>
                      <span style={{width:110,fontSize:12,color:'var(--n400)',
                        flexShrink:0,fontWeight:600,paddingTop:1}}>{k}</span>
                      {special==='status'?(
                        <StatusPicker value={sel.status}
                          options={STATUSES}
                          labels={SL}
                          colors={STATUS_COLORS}
                          onChange={changeStatus}/>
                       ):
                       special==='invoice'?<InvPill val={sel.invoice_status}/>:
                       <span style={{fontSize:13}}>{v}</span>}
                    </div>
                  );
                })}
                {sel.revenue>0&&(
                  <div style={{marginTop:12,padding:'12px 16px',
                    background:'var(--blue-50)',border:'1px solid var(--blue-pale)',
                    borderRadius:8}}>
                    <div style={{fontSize:11,color:'var(--n400)',marginBottom:2}}>Revenue commessa</div>
                    <div style={{fontSize:20,fontWeight:700,color:'var(--blue)'}}>{fmt(sel.revenue)}</div>
                  </div>
                )}

                {/* FiC integration box */}
                {(sel.fic_quote_id || sel.fic_invoice_id) && (
                  <div style={{marginTop:12,padding:'14px 16px',
                    background:sel.fic_invoice_id?'#DCFCE7':'#FEF3C7',
                    border:'1px solid '+(sel.fic_invoice_id?'#86EFAC':'#FDE68A'),
                    borderRadius:8}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                      <Icon name="receipt" size={14} color={sel.fic_invoice_id?'#166534':'#92400E'}/>
                      <div style={{fontWeight:600,fontSize:13,color:sel.fic_invoice_id?'#166534':'#92400E'}}>
                        {sel.fic_invoice_id ? 'Fatturato su FiC' : 'Preventivo FiC collegato'}
                      </div>
                    </div>
                    {sel.fic_invoice_number && (
                      <div style={{fontSize:12,color:'#166534',marginBottom:4}}>
                        Fattura n. <strong>{sel.fic_invoice_number}</strong>
                      </div>
                    )}
                    <div style={{display:'flex',gap:8,marginTop:10,flexWrap:'wrap'}}>
                      {sel.fic_invoice_url && (
                        <a href={sel.fic_invoice_url} target="_blank" rel="noopener"
                          className="btn btn-ghost btn-sm" style={{textDecoration:'none',fontSize:11}}>
                          <Icon name="external-link" size={11}/>Apri fattura FiC
                        </a>
                      )}
                      {sel.fic_quote_id && !sel.fic_invoice_id && (
                        <button className="btn btn-primary btn-sm" onClick={generateFicInvoice}
                          disabled={ficGenerating} style={{fontSize:11}}>
                          {ficGenerating ? <Spin/> : <Icon name="file-plus" size={11} color="#fff"/>}
                          Genera bozza fattura
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {drawerTab==='crew'&&(
              <div>
                {sel.required_roles?.length>0&&(
                  <div style={{fontSize:11,color:'var(--n400)',marginBottom:12,
                    display:'flex',alignItems:'center',gap:6}}>
                    <Icon name="users" size={11} color="var(--n400)"/>
                    {sel.required_roles.length} ruoli configurati  
                    <span style={{cursor:'pointer',color:'var(--blue)'}}
                      onClick={()=>setModal('edit')}>modifica composizione</span>
                  </div>
                )}
                <CrewPanel project={sel} onUpdate={()=>api(`/projects/${sel.id}`).then(setSel)}/>
              </div>
            )}

            {drawerTab==='budget'&&(
              <BudgetPanel project={sel} onEditClick={()=>setModal('edit')}/>
            )}

            {drawerTab==='docs'&&<DocsPanel project={sel}/>}
            {drawerTab==='msgs'&&<MsgsPanel project={sel}/>}
            {drawerTab==='mats'&&<MatsPanel project={sel}/>}
            {drawerTab==='veic'&&<VehiclesPanel project={sel}/>}
          </>
        )}
      </LargeModal>

      {/* Modal crea/modifica */}
      {modal&&(
        <Modal title={modal==='new'?'Nuovo cantiere':'Modifica cantiere'}
          onClose={()=>setModal(null)}>
          <ProjectForm
            project={modal==='edit'?sel:null}
            clients={clients} techs={techs}
            onSave={()=>{
              setModal(null);load();
              if(sel)api(`/projects/${sel.id}`).then(setSel);
            }}
            onClose={()=>setModal(null)}/>
        </Modal>
      )}
    </div>
  );
};

